<template>
   <div>
      <div class="form-group _margin-bottom-40">
         <div class="col-md-10">
            <form-label id="reminder_yes">
               Can {{ switchPlan.supplierName }} contract you via email and/or by mobile phone in order to send you
               reminders keeping you up-to-date with your account?
            </form-label>

            <div class="row">
               <div class="col-xs-6 col-sm-4">
                  <checkbox v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount">
                     Email
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox v-model="terms.supplierMaySendRemindersAndUpdatesViaTelephoneAboutAccount">
                     Mobile
                  </checkbox>
               </div>
            </div>
         </div>
      </div>

      <div class="form-group _margin-bottom-30">
         <div class="col-md-10">
            <form-label id="supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone">
               {{ switchPlan.supplierName }} would like to keep in touch about their other products and services.
            </form-label>
            <br />
            <small>Please select which channels they can do this by:</small>

            <div class="row">
               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaMobilePhone">
                     Mobile
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaEveningPhone"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaEveningPhone">
                     Evening Telephone
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaDayPhone"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaDayPhone">
                     Day Telephone
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaEmail"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaEmail">
                     Email
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaPost"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaPost">
                     Post
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaSms"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaSms">
                     SMS
                  </checkbox>
               </div>

               <div class="col-xs-6 col-sm-4">
                  <checkbox id="supplierMaySendUpdatesThatMayBeOfInterestViaFaceToFace"
                     v-model="terms.supplierMaySendUpdatesThatMayBeOfInterestViaFaceToFace">
                     Face to Face
                  </checkbox>
               </div>
            </div>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <checkbox id="supplierMaySendImportantAccountChangesViaEmail"
               v-model="terms.supplierMaySendImportantAccountChangesViaEmail">
               Can {{ switchPlan.supplierName }} contact you via email in order to send you details about important
               changes to your account; such as direct debit, price changes and contract information?
            </checkbox>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-12">
            <checkbox id="hasMedicalCondition" v-model="terms.hasMedicalConditionOrIndividualRequirement"
               @change="onChangeSpecialNeeds">
               I have a particular medical condition or individual requirement.<br />
               <small v-if="terms.hasMedicalConditionOrIndividualRequirement">Any information provided will be passed
                  onto your new Supplier, who may subsequently request further information from you.</small>
            </checkbox>
         </div>

         <div class="col-sm-8 _margin-top-20" v-if="terms.hasMedicalConditionOrIndividualRequirement">
            <form-label id="condition">Conditions</form-label>
            <validation-messages label="Condition" :$v="v.specialNeedsId">
               <select-list id="condition" v-model="terms.specialNeedsId" value-key="id" :list="specialNeedsList"
                  :error="v.specialNeedsId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <validation-messages label="Terms & Conditions Agreement" :$v="v.suppliersTermsAndConditionsAreAccepted">
               <checkbox id="termsAndConditions" v-model="terms.suppliersTermsAndConditionsAreAccepted"
                  :error="v.suppliersTermsAndConditionsAreAccepted.$error"
                  @change="terms.suppliersTermsAndConditionsAreAccepted = terms.suppliersTermsAndConditionsAreAccepted ? true : null">
                  Yes, I accept the energy supplier <a target="_blank" :href="switchPlan.supplierTosUrl">terms and
                     conditions</a>
               </checkbox>
            </validation-messages>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
   name: 'PfpEnergy',
   props: {
      v: Object
   },
   mounted() {
      this.terms.neitherSmartMeterInstalled = true;
      this.terms.gasSmartMeterInstalled = false;
      this.terms.electricitySmartMeterInstalled = false;
      this.terms.agreeSmartMeterConditions = false;
   },
   computed: {
      ...mapState({
         switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan,
         terms: ({ personal_details_terms }) => personal_details_terms,
         specialNeedsList: ({ lookups }) => lookups.specialNeeds,
         prepaymentList: ({ lookups }) => lookups.prepayments
      })
   },
   methods: {
      onChangeSpecialNeeds() {
         if (this.terms.hasMedicalConditionOrIndividualRequirement) {
            this.$store.dispatch('lookups/getSpecialNeedsList');
         } else {
            this.terms.specialNeedsId = null;
         }
      }
   }
};
</script>

<style lang="scss"></style>
